/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const LandmarkIconConfig = {
  name: 'LandmarkIcon',
  height: 512,
  width: 512,
  svgPath: 'M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(LandmarkIconConfig);